import { FieldBuilder } from './builder.js';
export class InterfaceFieldBuilder extends FieldBuilder {
    constructor(builder) {
        super(builder, "Interface", "Interface");
    }
}
//# sourceMappingURL=interface.js.map
